// src/components/UiFeedbackWidget/PickerOverlay.jsx
//
// Spec 20260925-ui-feedback §6.3, plan §5.6.1. Tasks T045.
//
// The visual half of pick mode: ONE fixed, pointer-events:none outline over the hovered
// element, an instruction bar at the top, and the crosshair rule for the <html> class the
// hook sets. It never touches a page element — the outline is its own div in a portal.

import React from 'react';
import { Box, GlobalStyles, Paper, Portal, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { PICKING_CLASS } from './useElementPicker';

export default function PickerOverlay({ picking, rect }) {
  const { t } = useTranslation();
  if (!picking) return null;
  return (
    <Portal>
      <GlobalStyles
        styles={{
          [`html.${PICKING_CLASS}, html.${PICKING_CLASS} *`]: { cursor: 'crosshair !important' },
        }}
      />
      <Paper
        data-ui-feedback-root
        role="status"
        elevation={6}
        sx={{
          position: 'fixed',
          top: 8,
          left: '50%',
          transform: 'translateX(-50%)',
          px: 2,
          py: 1,
          zIndex: (theme) => theme.zIndex.tooltip + 1,
          pointerEvents: 'none',
          maxWidth: 'calc(100vw - 32px)',
        }}
      >
        <Typography variant="body2">{t('Ideas.uiFeedback.pick_instruction')}</Typography>
      </Paper>
      {rect ? (
        <Box
          data-ui-feedback-root
          data-testid="ui-feedback-picker-outline"
          sx={{
            position: 'fixed',
            top: rect.top,
            left: rect.left,
            width: rect.width,
            height: rect.height,
            border: 2,
            borderColor: 'primary.main',
            borderRadius: 1,
            bgcolor: (theme) =>
              theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.06)' : 'rgba(154,63,105,0.08)',
            pointerEvents: 'none',
            zIndex: (theme) => theme.zIndex.tooltip + 1,
            transition: 'all 60ms linear',
          }}
        />
      ) : null}
    </Portal>
  );
}
